import { useNavigate } from "react-router-dom";

export default function ImageLibraryPanel({ isDark }: { isDark: boolean }) {
  const navigate = useNavigate();
  const headingColor = isDark ? "text-white" : "text-gray-800";
  const subColor = isDark ? "text-gray-400" : "text-gray-500";
  const cardBg = isDark ? "bg-gray-800 border-gray-700" : "bg-white border-gray-200";

  return (
    <div className={`rounded-2xl border p-5 ${cardBg}`}>
      <h3 className={`font-bold text-sm mb-1 ${headingColor}`}>
        <i className="ri-gallery-line text-pink-400 mr-1.5"></i>
        Image Gallery
      </h3>
      <p className={`text-xs mb-4 ${subColor}`}>
        Upload your own photos, manage the built-in library, set the hero background, and use any photo anywhere on the site.
      </p>
      <button
        onClick={() => navigate("/admin/gallery")}
        className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 rounded-full cursor-pointer whitespace-nowrap transition-colors flex items-center justify-center gap-2"
      >
        <i className="ri-gallery-line"></i>
        Open Image Gallery
      </button>
      <p className={`text-xs mt-3 ${subColor}`}>
        <i className="ri-information-line mr-1"></i>
        To replace any image on the site, go to the homepage in admin mode and hover over any image — click the pink <strong className={headingColor}>Gallery</strong> button.
      </p>
    </div>
  );
}